'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespaceCompat(e) {
    if (e && typeof e === 'object' && 'default' in e) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceCompat(React);

const SvgVeg20 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 20, height: 20, viewBox: "0 0 20 20", fill: "none" }, props),
    React__namespace.createElement("rect", { x: 1, y: 1, width: 18, height: 18, rx: 5, fill: "white" }),
    React__namespace.createElement("g", { clipPath: "url(#Veg20_svg__clip0_15100_43820)" },
        React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 18.25C7.59351 18.25 5.96468 18.2463 4.74682 18.0825C3.57931 17.9256 3.05479 17.651 2.7019 17.2981C2.34902 16.9452 2.07442 16.4207 1.91745 15.2532C1.75372 14.0353 1.75 12.4065 1.75 10C1.75 7.59351 1.75372 5.96468 1.91745 4.74682C2.07442 3.57931 2.34902 3.05479 2.7019 2.7019C3.05479 2.34902 3.57931 2.07442 4.74682 1.91745C5.96468 1.75372 7.59351 1.75 10 1.75C12.4065 1.75 14.0353 1.75372 15.2532 1.91745C16.4207 2.07442 16.9452 2.34902 17.2981 2.7019C17.651 3.05479 17.9256 3.57931 18.0825 4.74682C18.2463 5.96468 18.25 7.59351 18.25 10C18.25 12.4065 18.2463 14.0353 18.0825 15.2532C17.9256 16.4207 17.651 16.9452 17.2981 17.2981C16.9452 17.651 16.4207 17.9256 15.2532 18.0825C14.0353 18.2463 12.4065 18.25 10 18.25ZM0 10C0 5.28595 0 2.92893 1.46447 1.46447C2.92893 0 5.28595 0 10 0C14.714 0 17.0711 0 18.5355 1.46447C20 2.92893 20 5.28595 20 10C20 14.714 20 17.0711 18.5355 18.5355C17.0711 20 14.714 20 10 20C5.28595 20 2.92893 20 1.46447 18.5355C0 17.0711 0 14.714 0 10ZM10 15C12.7614 15 15 12.7614 15 10C15 7.23858 12.7614 5 10 5C7.23858 5 5 7.23858 5 10C5 12.7614 7.23858 15 10 15Z", fill: "#0F8A65" })),
    React__namespace.createElement("defs", null,
        React__namespace.createElement("clipPath", { id: "Veg20_svg__clip0_15100_43820" },
            React__namespace.createElement("rect", { width: 20, height: 20, fill: "white", transform: "matrix(-1 0 0 -1 20 20)" })))));

exports.default = SvgVeg20;
//# sourceMappingURL=Veg20.js.map
